import { Map } from './../classes.js';
import { screen_size_handler } from './../function/common.js';

document.addEventListener("DOMContentLoaded", function() {
	
	/*** RESIZE EVENT ***/
	window.render_size = 0;
	screen_size_handler();
	$(window).on('resize', function() {
		
		if(typeof(window.render_size) == 'undefined'
		|| Math.abs($(window).width() - window.render_size) > 100
		){
			screen_size_handler();
		}
		
	});
	
	/*** MAP LISTENER ***/
	if(Map){
		$('.mobile__map_switcher').addClass('active');
	}
	
	/*** MOBILE MENU ***/
	$('body').on('click', '.mobile_menu', function(e){
		$('.navigation').addClass('mobile_triggered');
		$('.navigation').toggle();
	});
	$('body').on('click', '.mobile_triggered li.has-dropdown', function(e){
		e.preventDefault();
		$(this).find('.navigation__dropdown').toggle();
	});
	$('body').on('click', '.navigation__dropdown-links', function(e){
		e.stopPropagation();
	});
	
	/*** MOBILE SEARCH ***/
	$('body').on('click', '.mobile_search', function(e){
		
		$('#lightbox_search').css("display", "flex").hide().fadeIn(200);
		
	});
	
	/*** MOBILE TRIPS ***/
	$('body').on('click', '.mobile_trip', function(e){
		
		window.location.href = "/u/trips";
		
	});
	
	
	/*** MAP SWITCHER ***/
	$('body').on('click', '.mobile__map_switcher', function(e){
		
		if($(this).hasClass('mobile__map_switcher--content')){
			$('.block__trip--two_col .col--sticky').addClass('active');
			
			$(this).removeClass('mobile__map_switcher--content');
			$(this).addClass('mobile__map_switcher--map');
			
			$(this).html(`
				<span class="material-symbols-outlined">
					arrow_menu_close
				</span>
				Content
			`);
		}else{
			$('.block__trip--two_col .col--sticky').removeClass('active');
			
			$(this).removeClass('mobile__map_switcher--map');
			$(this).addClass('mobile__map_switcher--content');
			
			$(this).html(`
				Map
				<span class="material-symbols-outlined">
					arrow_menu_open
				</span>
			`);
		}
		
	});
	
	
});